(function () {
    'use strict';

    // Salaris per leeftijd op basis van de CAO tabel
    const ageSalaries = {
        15: 12.00,
        16: 12.00,
        17: 12.00,
        18: 12.87,
        19: 13.49,
    };

    // Dienstjaar 1 salaris (voor 19 jaar en ouder)
    const serviceYearSalary = 15.52;

    function initSalaryCalculators(context) {
        const calculators = (context || document).querySelectorAll('[data-component="salary-calculator"]');

        calculators.forEach(calculator => {
            const ageInput = calculator.querySelector('#calc-age-slider');
            const hoursInput = calculator.querySelector('#calc-hours-slider');

            const resultText = calculator.querySelector('[data-result-text]');
            const hourlyResult = calculator.querySelector('[data-result-hourly]');
            const weeklyResult = calculator.querySelector('[data-result-weekly]');

            if (!ageInput || !hoursInput) return;

            function calculateAndDisplay() {
                const age = parseInt(ageInput.value, 10);
                const hours = parseInt(hoursInput.value, 10);
                
                // Bepaal het uurloon op basis van leeftijd
                let hourlyWage;
                if (age >= 20) {
                    hourlyWage = serviceYearSalary; // Dienstjaar 1
                } else {
                    hourlyWage = ageSalaries[age] || 12.00;
                }

                const weeklyWage = hourlyWage * hours;

                if (resultText) {
                    resultText.textContent = `Wanneer je ${hours} uur per week werkt en je bent ${age} jaar oud, dan verdien je per uur:`;
                }
                
                if (hourlyResult) {
                    hourlyResult.textContent = `€${hourlyWage.toFixed(2)}`;
                }
                
                if (weeklyResult) {
                    weeklyResult.textContent = `€${weeklyWage.toFixed(2)}`;
                }
            }

            ageInput.addEventListener('input', calculateAndDisplay);
            hoursInput.addEventListener('input', calculateAndDisplay);

            // Initial calculation
            calculateAndDisplay();
        });
    }

    // Initial load
    initSalaryCalculators();

    // Expose to global scope for re-initialization if needed
    window.initSalaryCalculators = initSalaryCalculators;

})();
